import { Stack } from 'expo-router';

import { IntegrationSettingsScreen } from '@/components/integrations/integration-settings-screen';
import { Text } from '@sixam/ui/text';

export default function UserSettingsIntegrationsScreen() {
  return (
    <>
      <Stack.Screen
        options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'Integrations' }}
      />
      <Stack.Screen.BackButton displayMode="minimal">Me</Stack.Screen.BackButton>
      <IntegrationSettingsScreen
        backHref="/app/me"
        ownerType="user"
        returnBasePath="/app/settings/integrations"
        header={
          process.env.EXPO_OS === 'web' ? undefined : (
            <Text variant="muted">Your connected accounts</Text>
          )
        }
        title="Integrations"
        subtitle="Your connected accounts"
      />
    </>
  );
}
